import React, { useMemo, useState } from 'react';
import { useAuth } from '../AuthProvider';
import { getApiErrorMessage, requestNumber, resolveCompanyId } from './CallCenterService';
import './CallCenter.css';

export default function RequestNumberPage() {
  const authContext = useAuth();
  const companyId = useMemo(() => resolveCompanyId(authContext?.additionalUserInfo), [authContext?.additionalUserInfo]);

  const [phoneNumber, setPhoneNumber] = useState('');
  const [description, setDescription] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const onSubmit = async (event) => {
    event.preventDefault();
    setSubmitting(true);
    setError('');
    setSuccess('');

    try {
      const payload = {
        phoneNumber,
        description,
      };

      await requestNumber(authContext.token, companyId, payload);
      setSuccess('Number request submitted.');
      setPhoneNumber('');
      setDescription('');
    } catch (err) {
      setError(getApiErrorMessage(err));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="call-center-page">
      <h1 className="call-center-title">Request a Number</h1>
      <p className="call-center-subtitle">Submit a request for a new number via AWS Connect allocate endpoint.</p>

      <form className="call-center-card" onSubmit={onSubmit}>
        <div className="call-center-grid">
          <label className="call-center-field">
            Desired Phone Number
            <input
              type="text"
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
              placeholder="e.g. +61400111222"
              required
            />
          </label>

          <label className="call-center-field">
            Description
            <input
              type="text"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Reason or notes"
            />
          </label>
        </div>

        <div className="call-center-actions">
          <button className="call-center-btn" type="submit" disabled={submitting}>
            {submitting ? 'Submitting...' : 'Submit Request'}
          </button>
        </div>

        {error && <div className="call-center-message call-center-message-error">{error}</div>}
        {success && <div className="call-center-message call-center-message-success">{success}</div>}
      </form>
    </div>
  );
}
